import type { Sport, SubscriptionProduct } from '@sharpr/types';

/** Looks up the active monthly product for `sport`, stages the unified
 *  pending_checkout payload, and navigates to /checkout/pending. The page
 *  POSTs to /api/billing/checkout-setup which detects the caller's existing
 *  live subs and runs in add-mode (inherits cohort trial_end / anchor /
 *  coupon / referral_code automatically).
 *
 *  Throws on network failure or no-active-product. Callers must `await` and
 *  handle errors (clear loading state, surface message) — fire-and-forget
 *  leaves the user with a stuck button on failure. */
export async function startAddSportCheckout(sport: Sport): Promise<void> {
  if (typeof window === 'undefined') return;
  const res = await fetch('/api/billing/products');
  if (!res.ok) {
    throw new Error(`Failed to load products: HTTP ${res.status}`);
  }
  const json = (await res.json()) as { data?: { products?: SubscriptionProduct[] } };
  const products = json.data?.products ?? [];
  const product = products.find((p) => p.is_active && p.sport === sport);
  if (!product) {
    throw new Error(`No active monthly product for ${sport.toUpperCase()}`);
  }
  window.localStorage.setItem(
    'pending_checkout',
    JSON.stringify({ productIds: [product.id] }),
  );
  window.location.href = '/checkout/pending';
}
